<template>
    <div class="sticky-page-container">
        <div v-if="$slots['aside-left']" ref="aside-left" class="sticky-page-container-aside" :style="styleAside">
            <slot name="aside-left"></slot>
        </div>
        <div class="sticky-page-container-content" :style="styleContent">
            <slot name="content"></slot>
        </div>
        <div v-if="$slots['aside-right']" ref="aside-right" class="sticky-page-container-aside" :style="styleAside">
            <slot name="aside-right"></slot>
        </div>
    </div>
</template>

<script>
import { install } from "resize-observer"

if (!window.ResizeObserver) {
    install()
}

export default {
    name: "StickyPageContainer",
    props: {
        delimiter: {
            type: Number,
            default: 30
        },
        styleContent: {
            type: Object,
            default: null
        },
        styleAside: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            asides: []
        }
    },
    mounted() {
        if (this.$slots["aside-left"]) {
            this.asides.push(this.$refs["aside-left"])
        }
        if (this.$slots["aside-right"]) {
            this.asides.push(this.$refs["aside-right"])
        }

        const observer = new ResizeObserver(entries => {
            window.requestAnimationFrame(() => {
                if (!Array.isArray(entries) || !entries.length) {
                    for (const aside of this.asides) {
                        this.computeHeight(aside)
                    }
                }
            })
        })

        for (const aside of this.asides) {
            observer.observe(aside)
            this.computeHeight(aside)
            document.addEventListener("scroll", () => {
                this.computeHeight(aside)
            })
            window.addEventListener("resize", () => {
                this.computeHeight(aside)
            })
        }
    },
    methods: {
        computeHeight(aside) {
            const { top, height } = aside.getBoundingClientRect()
            if (!height || top < 0) {
                return
            }
            const newHeight = window.innerHeight - top - this.delimiter

            if (newHeight > height) {
                for (let i = height; i < newHeight; i++) {
                    aside.style.height = `${i}px`
                }
            }
            if (newHeight < height) {
                for (let i = height; i > newHeight; i--) {
                    aside.style.height = `${i}px`
                }
            }
        }
    }
}
</script>

<style scoped lang="sass">
.sticky-page-container
    display: flex
    width: 100%
    justify-content: space-between
.sticky-page-container-aside
    position: sticky
    top: 10px
.sticky-page-container-content
    height: 100%
    width: 100%
    flex: 1
</style>
